import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@app/shared';
import {QrCodeComponent} from '@entities/qr-code/qr-code/qr-code.component';
import {QrCodeRoute} from '@entities/qr-code/qr-code.route';
import {RouterModule, Routes} from '@angular/router';
import {
  QrCodeDialogComponent,
  QrCodePopupComponent,
} from '@entities/qr-code/qr-code-dialog/qr-code-dialog.component';
import {
  QrCodeDialogExportPdfComponent,
  QrCodePopupExportPdfComponent,
} from '@entities/qr-code/qr-code-dialog-export-pdf/qr-code-dialog-export-pdf.component';
import {QrCodeDetailComponent} from '@entities/qr-code/qr-code-detail/qr-code-detail.component';
import {
  QrCodeDeleteDialogComponent,
  QrCodeDeletePopupComponent,
} from '@entities/qr-code/qr-code-delete-dialog/qr-code-delete-dialog.component';
import {
  QrCodeDialogUpdateActivityComponent,
  QrCodePopupUpdateActivityComponent,
} from '@entities/qr-code/qr-code-dialog-update-activity/qr-code-dialog-update-activity.component';
import {QrCodeDetailActivityComponent} from '@entities/qr-code/qr-code-detail-activity/qr-code-detail-activity.component';

const ENTITY_STATES = [...QrCodeRoute];

@NgModule({
  declarations: [
    QrCodeComponent,
    QrCodeDialogComponent,
    QrCodePopupComponent,
    QrCodeDialogExportPdfComponent,
    QrCodePopupExportPdfComponent,
    QrCodeDetailComponent,
    QrCodeDeletePopupComponent,
    QrCodeDeleteDialogComponent,
    QrCodeDialogUpdateActivityComponent,
    QrCodePopupUpdateActivityComponent,
    QrCodeDetailActivityComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(ENTITY_STATES as Routes),
  ],
  entryComponents: [
    QrCodeDialogComponent,
    QrCodeDialogExportPdfComponent,
    QrCodeDeleteDialogComponent,
    QrCodeDialogUpdateActivityComponent,
  ],
})
export class QrCodeModule {}
